import { createTheme } from '@mantine/core';

/** @type {[string, string, string, string, string, string, string, string, string, string]} */
export const pachubColourScheme = [
  '#ecf4ff',
  '#dce4f5',
  '#b9c7e2',
  '#94a8d0',
  '#748dc0',
  '#5f7cb7',
  '#5474b4',
  '#44639f',
  '#3a5890',
  '#2c4b80',
];

/** Shared Mantine theme for the tenant app and marketing site. */
export const theme = createTheme({
  colors: {
    pachubColourScheme,
  },
  primaryColor: 'pachubColourScheme',
  fontFamily: 'Inter Variable, sans-serif',
  respectReducedMotion: true,
  focusRing: 'auto',
});
